import { render, staticRenderFns } from "./govDetail.vue?vue&type=template&id=2050dd9a&scoped=true&"
import script from "./govDetail.vue?vue&type=script&lang=js&"
export * from "./govDetail.vue?vue&type=script&lang=js&"
import style0 from "./govDetail.vue?vue&type=style&index=0&id=2050dd9a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2050dd9a",
  null
  
)

export default component.exports